import React from "react";
import styles from "./DashboardSection.module.scss";

const DashboardSection = ({ title, children, className }) => {
  return (
    <div className={`${styles.section} ${className || ""}`}>
      {title && <h3 className={styles.title}>{title}</h3>}
      {children}
    </div>
  );
};

export default DashboardSection;
